import { PackageActionTypes, PackageState } from './Types';

export const CREATE_PACKAGE: PackageActionTypes = 'CREATE_PACKAGE';
export const GET_PACKAGES: PackageActionTypes = 'GET_PACKAGES';
export const UPDATE_PACKAGE: PackageActionTypes = 'UPDATE_PACKAGE';
export const GET_PACKAGE_REPORT: PackageActionTypes = 'GET_PACKAGE_REPORT';
export const DELETE_PACKAGE: PackageActionTypes = 'DELETE_PACKAGE';

export const INITIAL_PACKAGE_STATE: PackageState = {
  statusCode: 0,
  createdPackage: undefined,
  packages: []
};

export const NO_SHOW = 'No Shows';
export const VALID_CHECKINS = 'Valid Checkins';



// WEBPACK FOOTER //
// ./src/mms-package/Constants.tsx